import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/botFlow/importer/botFlowImporterActions';

export default importerReducers(actions);
